import { styled } from '@material-ui/core/styles';
import { Select } from '@material-ui/core';

export const PaginationWrapper = styled('div')(({ theme }) => ({
    paddingBottom: '8px',
    textAlign: 'center',
    fontSize: '12px',
    fontWeight: 500,
    color: theme.palette.text.secondary,
}));

export const CategorySelect = styled(Select)(({ theme }) => ({
    '&': {
        fontSize: 'inherit',
        fontWeight: 500,
        color: theme.palette.primary.main,
    },
    '& svg': {
        color: 'inherit',
    },

}));

export default {
    arrowButton: {
        width: '30px',
        height: '30px',
        backgroundColor: '#000',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        top: 0,
        bottom: 0,
        margin: 'auto',
        zIndex: 10000,
        cursor: 'pointer'
    },
    arrowPrev: {
        left: 0
    },
    arrowNext: {
        right: 0
    },
    arrowIcon: {
        fontSize: '25px',
        color: '#fff'
    },
    slideContainer: {
        height: '100%',
        width: '80%',
        margin: 'auto'
    },
    imageWrapper: {
        height: '70vh',
        width: '100%'
    },
    imageStyle: {
        width: '100%',
        height: '100%',
        objectFit: 'contain'
    }
}